<template>
  <section class="bg-color">
    <div class="container blog-display">
      <div class="inner-blog">
        <div class="row">
          <div class="col-md-8">
            <div class="blog-list news_block">
              <ul>
                <li v-for="data in fetchedData">
                  <div class="col-xs-4">
                    <div class="blog-image">
                      <router-link :to="'/blog/' + data.attributes.slug">
                        <img  v-bind:src="data.attributes.medium_image" class="img-responsive" alt="earth">
                      </router-link>
                    </div><!-- end blog-image -->
                  </div>
                  <div class="col-xs-8">
                    <div class="news_in blog-detail">
                      <p><router-link :to="'/blog/' + data.attributes.slug">{{data.attributes.title}}</router-link></p>
                        <small>{{data.attributes.event_date | convertDate}}</small>
                        <h6 class="para" >{{ data.attributes.description | truncate | escape }}</h6>
                    </div>
                  </div>
                  <div class="clear"></div>
                </li>
              </ul>
            </div><!-- end blog-list -->
            <div class="clear"></div>
            <!-- <nav aria-label="Page navigation nav-pg clearfix">
              <ul class="pagination">
              <li>
                <a href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li><a href="#" class="active">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li>
                <a href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
            </nav> -->
            <div class="clear"></div>
          </div><!-- end col -->
          <div class="col-md-4">
              <popular></popular>
          </div><!-- end col -->
        </div><!--end row -->
      </div><!-- end inner-blog -->
    </div><!-- end blog-display -->
  </section>
</template>
<script>
import {HTTP} from '../http-common.js'
import * as moment from 'moment-timezone'
import Popular from './Popular.vue'

export default {
  name: 'resources',
  data () {
    return {
      fetchedData: null,
      error: false,
      title : null,
    }
  },
  filters: {
  	truncate: function(string, value=150) {
      if(string.length <= value) {
       return string;
       }
       else {
           return string.substring(0, value) + '...';
       }

    },
    escape: function(text){
      var txt = document.createElement("textarea");
      txt.innerHTML = text;
      var text = txt.value;
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    },
    convertDate: function(date){
      return moment(date).format('MMMM Do, YYYY')
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  created: function(){
      this.fetchData()
  },
  methods : {
              fetchData(value='') {
                var itemId = this.$route.params.page;

                var url = 'category/'+itemId;
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.loading = false
                    this.fetchedData = jsonData.data.included
                    // console.log(this.fetchedData)
                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              }
  },
  components: {
      Popular
  }
}
</script>



// WEBPACK FOOTER //
// Resources.vue?3afba370